import type { Deal } from "@/lib/types/database/deals";
import { formatCurrency } from "@wtc/ui/lib/currency";

export const dealTitleTemplate = (deal: Deal) => deal.title;

export const dealDescriptionTemplate = (deal: Deal) => {
  const stageLabel = deal.stage.charAt(0).toUpperCase() + deal.stage.slice(1);
  const amountFormatted = formatCurrency(deal.revenue, { currency: deal.currency, fallback: "", minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return `${stageLabel} • ${amountFormatted} • ${deal.close_probability}% probability`;
};
